export default "__VITE_ASSET__Ywezv3Sr__"